module.exports = __webpack_public_path__ + "img/ic_marker_asset_lbl_leaf.4a375125.png";